export const roundDown = (n, p) => Math.floor(n / p) * p;
